import { TicketStatesTransferring, TicketStatesReceiving, TicketStatesGlobal } from '../../../components/ticket/ticket.constants';

export const TicketEventIcons = {
  'defaultIcon': 'fa fa-circle-o',
  [TicketStatesGlobal.REQUEST_STARTED]: 'fa fa-rocket',
  [TicketStatesGlobal.COMMENT_SAVED]: 'fa fa-commenting-o',

  [TicketStatesTransferring.RECEIVED_OUTGOING_REQUEST]: 'fa fa-inbox', // send-o
  [TicketStatesTransferring.REQUEST_DATA_COMPLETED]: 'fa fa-square-o',
  [TicketStatesTransferring.ACCEPT_OUTGOING_REQUEST]: 'fa fa-check-square-o',

  [TicketStatesReceiving.REQUEST_FORM_FILLED]: 'fa fa-file-text-o',
  [TicketStatesReceiving.WARRANT_SIGNED]: 'fa fa-pencil-square-o',
  [TicketStatesReceiving.INITIALIZATION_CONFIRMED]: 'fa fa-paper-plane-o',
  [TicketStatesReceiving.SENT_REQUEST_TO_TRANSFERRING]: 'fa fa-clock-o',
  [TicketStatesReceiving.OUTGOING_SIGNED_WARRANT_RENDERED]: 'fa fa-sign-out'
};

export const DocumentTypeDetection = {
  fax: /ViaFax$/i,
  email: /Via(E?)Mail$/i,
  letter: /ViaLetter$/i
};

export const HistoryDisplayMode = {
  event: {
    id: 1,
    label: 'Event',
    code: 'event'
  },
  time: {
    id: 2,
    label: 'Zeitpunkt',
    code: 'time'
  }
};

export const HistoryEventDateFormat = 'dd.MM.yyyy';

export const HistoryEventTimeFormat = 'HH:mm:ss';

// Used to split history details information comes from the backend
export const HistoryEventDetailsSplitter = ' || ';
